import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Circle,
  useMap,
} from "react-leaflet";
import { LatLngBounds, Icon } from "leaflet";
import { useEffect } from "react";
import "leaflet/dist/leaflet.css";

const storeIcon = new Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const proofIcon = new Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

interface ProofLocationMapProps {
  storeLocation: { latitude: number; longitude: number };
  proofLocation: { latitude: number; longitude: number };
  storeName?: string;
  proofAccuracy?: number | null;
}

function FitBounds({
  storeLocation,
  proofLocation,
}: {
  storeLocation: { latitude: number; longitude: number };
  proofLocation: { latitude: number; longitude: number };
}) {
  const map = useMap();

  useEffect(() => {
    const bounds = new LatLngBounds(
      [storeLocation.latitude, storeLocation.longitude],
      [proofLocation.latitude, proofLocation.longitude],
    );
    map.fitBounds(bounds, { padding: [50, 50] });
  }, [map, storeLocation, proofLocation]);

  return null;
}

export function ProofLocationMap({
  storeLocation,
  proofLocation,
  storeName,
  proofAccuracy,
}: ProofLocationMapProps) {
  const center: [number, number] = [
    (storeLocation.latitude + proofLocation.latitude) / 2,
    (storeLocation.longitude + proofLocation.longitude) / 2,
  ];

  return (
    <MapContainer
      center={center}
      zoom={15}
      style={{ height: "300px", width: "100%" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker
        position={[storeLocation.latitude, storeLocation.longitude]}
        icon={storeIcon}
      >
        <Popup>{storeName || "Store"}</Popup>
      </Marker>
      {proofAccuracy != null && proofAccuracy > 0 && (
        <Circle
          center={[proofLocation.latitude, proofLocation.longitude]}
          radius={proofAccuracy}
          pathOptions={{
            color: "#e53e3e",
            fillColor: "#e53e3e",
            fillOpacity: 0.2,
            weight: 1,
          }}
        />
      )}
      <Marker
        position={[proofLocation.latitude, proofLocation.longitude]}
        icon={proofIcon}
      >
        <Popup>Proof location</Popup>
      </Marker>
      <FitBounds storeLocation={storeLocation} proofLocation={proofLocation} />
    </MapContainer>
  );
}
